import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_20vdpzwnor: FaireBrandEntity = {
  token: "b_20vdpzwnor",
  type: "brand",
  name: "Laughing Elephant",
  avatarUrl:
    "https://cdn.faire.com/fastly/cd4b609720b2bf867e9f179b173ad303a3079041552143618ac4dec151310738.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/49be345824c55f94fe53a8d86b01a517e206b4407551b1a59e744c89a954dbfd.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/cd4b609720b2bf867e9f179b173ad303a3079041552143618ac4dec151310738.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/49be345824c55f94fe53a8d86b01a517e206b4407551b1a59e744c89a954dbfd.jpeg",
  location: "Seattle, WA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 165,
  isTopShop: true,
  isInsider: true,
  description:
    "Founded in 1969, our third-generation family business uses vintage illustrations as designs for greeting cards and paper goods. We aim to share the superb designs of the golden age of illustration in products that convey care, kindness, and love.\n\nWe are experts in vintage art, collecting a vast archive of images from the late 1800s to the 1970s. We utilize these beautiful children’s books, advertisements, scrapbooks, and posters to add heartfelt inspiration to people’s lives.\n\nWhat you will not find in our products is cynicism, black humor, or ugly portrayals of people or animals. We hope to uplift, amuse, encourage, and comfort with our designs and messages.\n\nThank you so much for choosing our small family business from Seattle!",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:44.447Z",
    importedBy: "entity-db-cli",
  },
};
